var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('TheHeader'),_c('Lange'),_c('ContactBTN'),_c('Situation'),_c('Wie'),_c('Kraft'),_c('AlleKraft'),_c('Ankommt'),_c('Name'),_c('Contact',{attrs:{"id":"kontakt"}}),_c('TheFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }